module.exports = __webpack_public_path__ + "media/newMessage.8a8b917c.mp3";